<span *ngIf="msg.length > 145" matTooltip="{{ msg }}">{{ msg }}</span>
<span *ngIf="msg.length <= 145">{{ msg }}</span>
